// ================== SEARCH INPUT IN HEADER ==================
const searchDetails = document.querySelector('.header__search details');

let lastWidth = document.documentElement.clientWidth;

function updateDetailsState() {
  const currentWidth = document.documentElement.clientWidth;

  // Desktop: always open
  if (currentWidth >= 1300) {
    searchDetails.setAttribute('open', '');
  } else {
    // Mobile: always closed on load/resize
    searchDetails.removeAttribute('open');
  }
}

function handleResize() {
  const currentWidth = document.documentElement.clientWidth;

  // Ignore scroll-triggered resize (height changes)
  if (currentWidth === lastWidth) return;
  lastWidth = currentWidth;

  updateDetailsState();
}

// ---- Run on page load ----
updateDetailsState();

// ---- Run on true resize ----
window.addEventListener('resize', handleResize);

// ---- Keep open while scrolling on desktop ----
window.addEventListener('scroll', () => {
  if (document.documentElement.clientWidth >= 1300) {
    searchDetails.setAttribute('open', '');
  }
});


// ================== NEWSLETTER POPUP ==================
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('newsletter-popup');

  // Run only if modal exists
  if (!modal) return;

  const closeBtn = document.getElementById('closeNewsletterPopup');
  const closeButton = document.getElementById('closeButton');

  function openModal() {
    modal.style.display = 'flex';
    document.body.classList.add('overflow-hidden');
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  }

  // Auto-open after delay
  setTimeout(() => {
    openModal();
  }, 2000);

  // Close icon button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // Optional secondary close button
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  // Close by clicking outside content
  window.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });
});


// ================== DROPDOWN OPEN IN HOVER ==================
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
  item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
  });
    item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
    });
  });
});